import { request } from '@/utils/request';

const urls = {
  list: '/api/workbench/positionManager/pagingPositions', // 列表
  delete: '/api/workbench/posts/deletes', // 删除
  detail: '/api/workbench/positionManager/getDetail', // 详情
};
function cleanArray (actual) {
  const newArray = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < actual.length; i ++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}
function param (json) {
  if (!json) return '';
  return cleanArray(Object.keys(json)?.map((key) => {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key]);
  }))?.join('&');
}
export async function reqList (params) {
  const query = param(params);
  const url = `${urls.list}?${query}`;
  return request(url);
}

export async function reqDelete (params) {
  const { id } = params || {};
  if (!id) return;
  const url = `/api/workbench/posts/${id}/delete`;
  return request(url, {
    method: 'POST',
  });
}

export async function patchDelete (params) {
  const { ids = [] } = params || {};
  return request('/api/workbench/posts/deletes', {
    method: 'POST',
    data: ids,
  });
}

export async function reqDetail (params) {
  return request(urls.detail, {
    params,
  });
}


export async function addOrEdit (params) {
  const { id } = params;
  let url = '/api/workbench/posts/create';
  if (id) {
    url = `/api/workbench/posts/${id}/update`;
  }
  return request(url, {
    method: 'POST',
    data: params,
  });
}

export async function getUserCategoryTree (params) {
  return request('/api/workbench/userCategories/getHasRoleCategory', {
    params,
  });
}

export async function getRoleTreeByCategory (params) {
  return request('/api/workbench/privileges/getRoleTree4RoleGroup', {
    params,
  });
}

export async function updateStatus (params) {
  return request('/api/workbench/posts/updateStatus', {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

export async function getOrgPostTemplate (params) {
  return request('/api/positionManager/getOrgPostTemplate', {
    params,
  });
}

export async function changeTemplate (params) {
  const url = `/api/workbench/posts//template/change/${params.id}`;
  return request(url, {
    method: 'post',
    data: params,
  });
}

/**
 * 获取系统管理角色列表
 * @param {*} params 
 */
export async function fetchRoleList (params) {
  const url = ' /api/roles/pagingValidRoles';
  return request(url, {
    params,
  });
}

/**
 * 获取个人角色详情
 * @param {*} params 
 */
export async function getRoleDetail (params) {
  const roleId = params.roleId || '';
  const url = `/api/roles/${roleId}`;
  return request(url, {
    params,
  });
}

/**
 * 获取个人岗位列表
 * @param {*} params 
 */
export async function fetchPagingPositions (params) {
  const url = '/api/positionManager/pagingPositions';
  return request(url, {
    params,
  });
}

/**
 * 获取个人岗位详情
 * @param {*} params 
 */
export async function getPosDetail (params) {
  const url = '/api/workbench/positionManager/getDetail';
  return request(url, {
    params,
  });
}

/**
 * 获取功能树
 * @param {*} params 
 */
export async function getPrivilegeTree (params) {
  const url = '/api/privileges/getPrivilegeTree';
  return request(url, {
    params,
  });
}

/**
 * 获取功能树
 * @param {*} params 
 */
export async function getPrivilegeDetail (params) {
  const url = '/api/privileges/detail';
  return request(url, {
    params,
  });
}

export async function getHasRoleCategory (params) {
  const url = '/api/workbench/userCategories/getHasRoleCategory';
  return request(url, {
    params,
  });
}
/**
 * 校验岗位关联的产品功能是否有仅关联父未关联子的情况
 * @param {*} params 
 * @returns 
 */
export async function checkRoleGroupRoles (params) {
  const url = '/api/workbench/positionManager/checkRoleGroupRoles';
  return request(url, {
    params,
  });
}

/**
 * 新增或编辑岗位时，校验该用户类别下的功能树元数据
 * @param {*} params 
 * @returns 
 */
export async function checkRoleTree4RoleGroup (params) {
  const url = '/api/workbench/privileges/checkRoleTree4RoleGroup';
  return request(url, {
    params,
  });
}


